let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lRPUn")).then(() => parcelRequire('h7M99'));